import { Hostname, Realm } from "./types";

export const realmToHost: Record<Realm, Hostname> = {
  [Realm.prod]: Hostname.prod,
  [Realm.stage]: Hostname.stage,
  [Realm.dev]: Hostname.dev,
  [Realm.local]: Hostname.local,
};

export const chatWidgetVersion = "1.0.570";
